store.attributeSort = [];
store.attributes = {};
store.variants = {};
store.initialProductClasses = [];

store.initAttributes = function(data, currentVariantKey) {
	var $store = store.$();
	var wrap = $store.find('.variantSelection');
	var html = '';
	store.attributeSort = data.attributeSort;
	store.attributes = data.attributes;
	store.variants = data.variants;
	store.initialProductClasses = $store.find('.product').attr('class').split(' ');

	for (var i= 0,c=data.attributeSort.length; i<c; i++) {
		var aId = data.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		var a = data.attributes[aId];
		var aData = a.data;
		if (aData.isOption) {
			var selectId = 'attribute_' + aData.codename;
			a.selectId = selectId;
			var label = '<label for="' + selectId + '">' + aData.name + ':</label>';
			var aType = aData.type;
			var select = '';
			if (aType == 'color') {
				select = store.attributeColorSelect(selectId, a.values);
			}
			else {
				select = store.attributeNormalSelect(selectId, a.values);
			}

			html += '<div class="attribute">' + label + select + '</div>';
		}
	}
	wrap.html(html);
	$store.find('.attribute select').change(function(){
		store.updateVariantData();
	});
	$store.find('.attribute span.color').click(store.updateVariantColor);
	store.selectVariant(currentVariantKey);
};

store.attributeNormalSelect = function(selectId, values) {
	var options = '';
	for (var vId in values) {
		//noinspection JSUnfilteredForInLoop
		var v = values[vId];
		options += '<option value="' + vId.replace('v', '') + '">' + v.value + '</option>';
	}
	return '<select id="' + selectId + '">' + options + '</select>';
};
store.AttributeValue = {
	extraValue: null
};
store.attributeColorSelect = function(selectId, values) {
	var options = '';
	for (var vId in values) {
		//noinspection JSUnfilteredForInLoop
		var v = values[vId];
		var vvId = vId.replace('v', '');
		if (v.extraValue.indexOf('#') !== 0) {
			v.extraValue = '#' + v.extraValue;
		}
		options += '<span class="color c_' + vvId +
			'" style="background: ' + v.extraValue + '" rel="' + vvId +
			'" title="' + v.value + '">&nbsp;</span>';
	}
	var hidden = '<input type="hidden" name="' + selectId + '" id="' + selectId + '" />';
	return '<span class="colorWrap" id="' + selectId + '_wrap">' + hidden + options + '</span>';
};

store.updateVariantColor = function() {
	var t = $(this);
	var rel = t.attr('rel');
	var p = t.parent();
	$('input', p).val(rel);
	store.updateVariantData();
};
store.Variant = {
	price: null,
	stock: null,
	qty: null,
	reference: null,
	compareLink: null,
	attributes: null,
	img: null,
	priceId: null
};
store.Attribute = {
	name: null, codename: null, type: null, isOption: null
};
store.getVariantAttributeData = function(variant) {
	var ret = {};
	if (variant && variant.attributes) {
		for (var k in variant.attributes) {
			if (variant.attributes.hasOwnProperty(k)) {
				var kk = 'a'+k;
				if (store.attributes[kk] && store.attributes[kk].data.codename) {
					ret[store.attributes[kk].data.codename] = variant.attributes[k];
				}
			}
		}
	}
	return ret;
};
store.updateVariantClasses = function(variant) {
	var $product = store.$().find('.product');
	var classes = store.initialProductClasses;
	var variantClasses = variant.classes;
	if (variantClasses) {
		classes = classes.concat(variantClasses);
	}
	$product.attr('class', classes.join(' '));
};
store.updateVariantData = function() {
	var values = [];
	var aId, a, sel, i, c;
	for (i = 0,c = store.attributeSort.length; i < c; i++) {
		aId = store.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		a = store.attributes[aId];
		if (a.selectId) {
			//noinspection JSJQueryEfficiency
			sel = $('#' + a.selectId);
			var v1 = sel.val();
			if (v1) {
				v1 = parseInt(v1);
				values.push(v1);
			}
		}
	}

	var key = values.join('_');
	if (store.variants[key]) {
		var variant = store.variants[key];
		var $store = store.$();
		$store.find('.buyBox .priceDetail .priceValue').html(variant.price);
		$store.find('.availability').replaceWith(variant.stock);
		$store.find('div.qtyWrap').replaceWith(variant.qty);
		$store.find('div.reference').replaceWith(variant.reference);
		if (variant.compareLink) {
			$store.find('div.compareLink').replaceWith(variant.compareLink);
		}

		$store.find('.product .side .image').replaceWith(variant.img);
		$store.find('.product .side .image a.fancybox').fancybox();
		store.responsiveImg($store.find('.product .side .image'));
		$store.find('#variant').val(variant.id).trigger('change');
		$store.find('#price').val(variant.priceId).trigger('change');
		store.updateAttributes(variant);
		store.updateBuyButton();
		store.updateVariantClasses(variant);

		for (i= 0,c=store.attributeSort.length; i<c; i++) {
			aId = store.attributeSort[i];
			//noinspection JSUnfilteredForInLoop
			a = store.attributes[aId];
			if (a.data.type == 'color') {
				//noinspection JSJQueryEfficiency
				sel = $('#' + a.selectId);
				var v2 = sel.val();
				var wrap = $('#' + a.selectId + '_wrap');
				wrap.find('.color').removeClass('selected');
				wrap.find('.c_' + v2).addClass('selected');
			}
		}
		store.local.onUpdateVariantData(variant);
	}
	else {
		store.message.error(store.t.__('variantNotAvailable'), 'Error', null, 'updateVariantData');
	}
};

store.updateAttributes = function(variant) {
	var $table = store.$().find('.attributesValues table');
	if ($table.length > 0) {
		$table.find('tr').each(function() {
			var $t = $(this);
			var r = parseInt($t.attr('rel'));
			if (r > 0 && variant.attributes) {
				var t = (variant.attributes[r]) ? variant.attributes[r] : '';
				$t.find('td').text(t);
			}
		});
	}
	store.local.onUpdateAttribute(variant);
};
store.updateBuyButton = function() {
	var allowedToAdd = (store.$().find('div.qtyWrap #qty').length > 0);
	store.$().find('#submitCart').attr('disabled', !allowedToAdd);
};

store.selectVariant = function (currentVariantKey)
{
	var values = currentVariantKey.split('_');
	for (var i= 0,cas=store.attributeSort.length; i<cas; i++) {
		var aId = store.attributeSort[i];
		for (var v= 0, c=values.length; v < c; v++) {
			var vId = values[v];
			var vvId = 'v'+vId;
			//noinspection JSUnfilteredForInLoop
			if (store.attributes[aId].values[vvId]) {
				//noinspection JSUnfilteredForInLoop
				var e = $('#' + store.attributes[aId].selectId);
				e.val(vId);
			}
		}
	}
	store.updateVariantData();
	store.local.onSelectVariant(currentVariantKey);
};
